import React from "react";
export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""} ${disabled ? "disabled" : ""}`}
    onClick={disabled ? null : onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 24C4.94772 24 4.5 23.5523 4.5 23V21.5714C4.5 21.0191 4.94772 20.5714 5.5 20.5714H22.6998C23.2521 20.5714 23.6998 21.0191 23.6998 21.5714V23C23.6998 23.5523 23.2521 24 22.6998 24H5.5ZM5.5 17.1428C4.94772 17.1428 4.5 16.6951 4.5 16.1428V14.7143C4.5 14.162 4.94772 13.7143 5.5 13.7143H22.6998C23.2521 13.7143 23.6998 14.162 23.6998 14.7143V16.1428C23.6998 16.6951 23.2521 17.1428 22.6998 17.1428H5.5ZM4.5 9.2857C4.5 9.83799 4.94772 10.2857 5.5 10.2857H16.2999C16.8522 10.2857 17.2999 9.83799 17.2999 9.2857V7.85713C17.2999 7.30484 16.8522 6.85713 16.2999 6.85713H5.5C4.94772 6.85713 4.5 7.30484 4.5 7.85713V9.2857ZM20.5 8.45403C20.5 9.24519 21.3752 9.72303 22.0408 9.2952L27.1915 5.98402C27.8038 5.59038 27.8038 4.6953 27.1914 4.30166L22.0408 0.99048C21.3752 0.562647 20.5 1.04049 20.5 1.83166V8.45403Z"
      fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
    />
  </svg>
);
